import React from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer>
      <span>redtoblue /{t("header.component")}</span>
      <span>All rights reserved 2023</span>
    </footer>
  );
};
export default Footer;
